import { useMemo } from "react";
import { MealSchedule } from "@corpuscomplete/core/nutrition/meal-schedule";
import { NIL_UUID } from "@corpuscomplete/core/utils";
import { queries } from "@corpuscomplete/core/zero";
import { useQuery } from "@corpuscomplete/zero-data-transformer/react";

export namespace MealScheduleUI {
  export function useByScope(scopeId: string | undefined) {
    return useQuery(queries.mealSchedule.byScope({ scopeId: scopeId ?? NIL_UUID }), {
      enabled: !!scopeId,
    });
  }

  export function useTypeLabelOptions(scopeId: string | undefined): string[] {
    const [schedules] = useByScope(scopeId);
    return useMemo(
      () => (scopeId ? MealSchedule.distinctSlotNames(schedules) : []),
      [scopeId, schedules],
    );
  }
}
